"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataGrid = exports.useDataGridRef = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ag_grid_react_1 = require("ag-grid-react");
var DateEditor_1 = require("./custom/DateEditor");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = require("react");
var date_fns_1 = require("date-fns");
var R = __importStar(require("../../utils/ramda"));
require("ag-grid-community/styles/ag-grid.css");
require("ag-grid-community/styles/ag-theme-alpine.css");
require("./DataGrid.css");
var TopPanel_1 = require("./TopPanel");
var ColumnHandler_1 = require("./ColumnHandler");
var consoleHandler_1 = require("../../utils/consoleHandler");
var en_US_1 = __importDefault(require("date-fns/locale/en-US"));
var DGENOAUTH_1 = require("./DGENOAUTH");
var Select_1 = require("../../components/Select");
var react_dom_1 = require("react-dom");
var TitleBox_1 = require("./TitleBox");
var Box_1 = require("../../components/Box");
var intl_1 = require("./intl");
var intl_2 = require("../../components/Pagination/intl");
var useIntlMock_1 = require("../../utils/useIntlMock");
var useDataGridRef = function () {
  var ref = (0, react_1.useRef)(null);
  return ref;
};
exports.useDataGridRef = useDataGridRef;
/** Returns a set of options that disables all enterprise features */
var enterpriseShield = function (enterprise) {
  return enterprise ? {} : {
    sideBar: null,
    statusBar: undefined,
    suppressContextMenu: true,
    enableRangeSelection: false,
    enableRangeHandle: false,
    enableFillHandle: false,
    suppressExcelExport: true,
    suppressExpandablePivotGroups: true,
    masterDetail: false,
    rowGroupPanelShow: "never"
  };
};
var DataGrid = function (_a) {
  var _b = _a.dateFormat,
    dateFormat = _b === void 0 ? "dd-MMM-yyyy" : _b,
    _c = _a.dateLocale,
    dateLocale = _c === void 0 ? en_US_1.default : _c,
    title = _a.title,
    caption = _a.caption,
    rowData = _a.rowData,
    getRowId = _a.getRowId,
    defaultColDef = _a.defaultColDef,
    _d = _a.onGridReady,
    onGridReady = _d === void 0 ? R.N : _d,
    topPanel = _a.topPanel,
    rowSelection = _a.rowSelection,
    columnDefs = _a.columnDefs,
    rowActions = _a.rowActions,
    _e = _a.headerTopBorder,
    headerTopBorder = _e === void 0 ? false : _e,
    _f = _a.readOnlyEdit,
    readOnlyEdit = _f === void 0 ? true : _f,
    context = _a.context,
    containerProps = _a.containerProps,
    _g = _a.paginationSizes,
    paginationSizes = _g === void 0 ? [10, 50, 100] : _g,
    _pagination = _a.pagination,
    _h = _a.paginationPageSize,
    paginationPageSize = _h === void 0 ? 50 : _h,
    _j = _a.tooltipShowDelay,
    tooltipShowDelay = _j === void 0 ? 1000 : _j,
    headerCheckboxSelectionFilteredOnly = _a.headerCheckboxSelectionFilteredOnly,
    headerBoxProps = _a.headerBoxProps,
    _k = _a.intl,
    intl = _k === void 0 ? (0, useIntlMock_1.useIntlMock)() : _k,
    topPanelGrow = _a.topPanelGrow,
    _l = _a.suppressRowClickSelection,
    suppressRowClickSelection = _l === void 0 ? true : _l,
    _m = _a.__enterprise__,
    enterprise = _m === void 0 ? false : _m,
    gridRef = _a.gridRef,
    restProps = __rest(_a, ["dateFormat", "dateLocale", "title", "caption", "rowData", "getRowId", "defaultColDef", "onGridReady", "topPanel", "rowSelection", "columnDefs", "rowActions", "headerTopBorder", "readOnlyEdit", "context", "containerProps", "paginationSizes", "pagination", "paginationPageSize", "tooltipShowDelay", "headerCheckboxSelectionFilteredOnly", "headerBoxProps", "intl", "topPanelGrow", "suppressRowClickSelection", "__enterprise__", "gridRef"]);
  var className = (0, classnames_1.default)("vsx-data-grid", containerProps === null || containerProps === void 0 ? void 0 : containerProps.className, headerTopBorder && "vsx-data-grid-header-top-border", !enterprise && "no-enterprise");
  var _o = __read((0, react_1.useState)(), 2),
    topPanelProps = _o[0],
    setTopPanelProps = _o[1];
  var _p = __read((0, react_1.useState)(paginationPageSize), 2),
    _paginationSize = _p[0],
    setPaginationSize = _p[1];
  var _columnDefs = (0, react_1.useMemo)(function () {
    return (0, ColumnHandler_1.handleColumns)({
      columnDefs: columnDefs,
      rowActions: rowActions,
      rowSelection: rowSelection,
      enterprise: enterprise,
      headerCheckboxSelectionFilteredOnly: headerCheckboxSelectionFilteredOnly
    });
  }, [columnDefs, rowActions, rowSelection, enterprise, headerCheckboxSelectionFilteredOnly]);
  var _getRowId = (0, react_1.useCallback)(function (item) {
    return getRowId(item).toString();
  }, [getRowId]);
  var _onGridReady = (0, react_1.useCallback)(function (e) {
    setTopPanelProps(__assign({}, e));
    onGridReady(e);
    e.api.setGridOption("paginationPageSize", paginationPageSize);
  }, [onGridReady]);
  var _defaultColDef = (0, react_1.useMemo)(function () {
    return __assign({
      editable: false,
      sortable: true
    }, defaultColDef);
  }, [defaultColDef]);
  var _dateColumnType = (0, react_1.useMemo)(function () {
    return dateColumnType(dateFormat, dateLocale);
  }, [dateFormat, dateLocale]);
  var gridContainerRef = (0, react_1.useRef)(null);
  var pageSizeSelector = (0, react_1.useMemo)(function () {
    var _a;
    var pagingPanel = (_a = gridContainerRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(".ag-paging-panel");
    if (pagingPanel) {
      var options = paginationSizes === null || paginationSizes === void 0 ? void 0 : paginationSizes.map(function (size) {
        return {
          label: (0, intl_2.rowPerPageIntl)(size, intl),
          value: size
        };
      });
      var select = (0, jsx_runtime_1.jsx)(Select_1.Select, {
        menuPlacement: "top",
        className: "vsx-data-grid-paging-select",
        isMulti: false,
        value: options.find(function (v) {
          return v.value === (topPanelProps === null || topPanelProps === void 0 ? void 0 : topPanelProps.api.paginationGetPageSize());
        }),
        isSearchable: false,
        options: options,
        onChange: function (v) {
          topPanelProps === null || topPanelProps === void 0 ? void 0 : topPanelProps.api.paginationSetPageSize(v.value);
          setPaginationSize(v.value);
        }
      });
      return (0, react_dom_1.createPortal)(select, pagingPanel);
    }
    return null;
  }, [_pagination, gridContainerRef, gridContainerRef.current, topPanelProps, topPanelProps === null || topPanelProps === void 0 ? void 0 : topPanelProps.api, topPanelProps === null || topPanelProps === void 0 ? void 0 : topPanelProps.api.paginationGetPageSize(), paginationSizes, setPaginationSize]);
  if (enterprise && !restProps.EXPLICIT_ENTERPRISE_AUTH_DO_NOT_USE_WITHOUT_PERMISSION) {
    return DGENOAUTH_1.DGENOAUTH;
  }
  var locale = (0, react_1.useMemo)(function () {
    return (0, intl_1.createDataGridIntl)(intl);
  }, [intl]);
  return (0, jsx_runtime_1.jsxs)("div", __assign({}, containerProps, {
    ref: gridContainerRef,
    className: className
  }, {
    children: [(0, jsx_runtime_1.jsxs)(Box_1.Box, __assign({
      direction: "row",
      justify: "space-between",
      align: "center",
      wrap: false
    }, headerBoxProps, {
      children: [(0, jsx_runtime_1.jsx)(TitleBox_1.TitleBox, {
        title: title,
        caption: caption
      }), (0, jsx_runtime_1.jsx)(TopPanel_1.TopPanel, {
        grow: topPanelGrow,
        topPanelComponent: topPanel,
        api: topPanelProps === null || topPanelProps === void 0 ? void 0 : topPanelProps.api
      })]
    })), (0, jsx_runtime_1.jsx)(ag_grid_react_1.AgGridReact, __assign({
      ref: gridRef,
      localeText: locale,
      enableCellTextSelection: true
    }, restProps, {
      getRowId: function (p) {
        return _getRowId(p.data);
      },
      context: __assign(__assign({}, context), {
        getRowId: _getRowId,
        readOnlyEdit: readOnlyEdit
      }),
      columnDefs: _columnDefs,
      defaultColDef: _defaultColDef,
      rowData: rowData,
      columnTypes: __assign(__assign({}, restProps.columnTypes), {
        __static__: staticColumnType,
        date: _dateColumnType
      }),
      suppressDragLeaveHidesColumns: true,
      suppressRowClickSelection: suppressRowClickSelection,
      pagination: _pagination,
      paginationPageSize: _paginationSize,
      rowSelection: rowSelection,
      onGridReady: _onGridReady,
      readOnlyEdit: readOnlyEdit,
      tooltipShowDelay: tooltipShowDelay
    }, enterpriseShield(enterprise), {
      className: "ag-theme-alpine",
      paginationPageSizeSelector: false
    })), pageSizeSelector]
  }));
};
exports.DataGrid = DataGrid;
var dateColumnType = function (dateFormat, locale) {
  if (locale === void 0) {
    locale = en_US_1.default;
  }
  return {
    filter: "agDateColumnFilter",
    filterParams: {
      filterOptions: ["empty", "greaterThan", "lessThan", "inRange", "notBlank", "blank"]
    },
    cellEditor: DateEditor_1.DateEditor,
    cellEditorParams: {
      dateFormat: dateFormat,
      locale: locale
    },
    // suppressKeyboardEvent: (p) => p.editing && p.event.key === "Enter",
    valueFormatter: function (p) {
      return R.isNil(p.value) ? "" : (0, date_fns_1.format)(p.value, dateFormat || "dd-MMM-yy", {
        locale: locale
      });
    }
  };
};
var staticColumnType = {
  filter: false,
  editable: false,
  resizable: false,
  sortable: false,
  suppressAutoSize: true,
  suppressSizeToFit: true,
  suppressColumnsToolPanel: true,
  suppressMenu: true,
  lockPinned: true,
  lockPosition: true,
  lockVisible: true
};
// hacky fix for https://github.com/facebook/react/issues/21035
(0, consoleHandler_1.suppressConsoleError)(function (m) {
  return m.startsWith("Warning: Invalid aria prop");
});
// TODO provide a proper fix for this
(0, consoleHandler_1.suppressConsoleError)(function (m) {
  return m.startsWith("Warning: Cannot update a component");
});
// Prevent log spam about unused features
(0, consoleHandler_1.suppressConsoleWarning)(function (m) {
  return m.includes("only valid with AG Grid Enterprise");
});
(0, consoleHandler_1.suppressConsoleWarning)(function (m) {
  return m.includes("only valid in ag-grid-enterprise");
});
(0, consoleHandler_1.suppressConsoleWarning)(function (m) {
  return m.startsWith("AG Grid: unable to use");
});